import { createSlice } from '@reduxjs/toolkit';
import { getPayoffPayments } from 'thunks';
import { PayoffPaymentResponse } from 'api/PayoffApi';

export interface PayoffPaymentsState {
  payments: PayoffPaymentResponse[];
  isLoading: boolean;
  isError: boolean;
  errorMessage: string | null;
}

const initialState: PayoffPaymentsState = {
  payments: [],
  isLoading: false,
  isError: false,
  errorMessage: null,
};

const payoffPaymentsSlice = createSlice({
  name: 'payoffPayments',
  initialState,
  reducers: {
    clearPayoffPayments: (state) => {
      state.payments = [];
      state.isError = false;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPayoffPayments.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getPayoffPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.payments = action.payload.payments;
      })
      .addCase(getPayoffPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message || 'Failed to load payments';
      });
  },
});

export const { clearPayoffPayments } = payoffPaymentsSlice.actions;
export default payoffPaymentsSlice.reducer;
